import React, { useEffect, useState } from 'react';
import { useSelector/* , useDispatch */ } from 'react-redux';
import { RootState/* , MyThunkDispatch */ } from 'store';

/* import { fetchHasAccess } from 'actions/accessLog'; */
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import RejectedReasonList from 'screens/components/RejectedReasonList';
import { TravelReason } from 'models/travelReseller';
import { getRejectedReasonList } from 'services/resellerTravel';

const RejectedReasonContainer = () => {
/*   const dispatch: MyThunkDispatch = useDispatch(); */
  const [rejectedReasonList, setRejectedReasonList] = useState<TravelReason[]>([]);
  const [isLoading, setLoading] = useState(false);
  const toast = useToast();
  const { t } = useStoreTranslation();
  /* estados globales */
  const companyId = useSelector((state: RootState) => state.user.accountResult?.companyId);
  /* const adminId = useSelector((state: RootState) => (state.user.accountResult ? state.user.accountResult?.id : '')); */
  const tourLoading = useSelector((state: RootState) => state.accessLog.isLoading);
  /* const hasAccess = useSelector((state: RootState) => state.accessLog.ListGroups); */

  /*   useEffect(() => {
    const screenName = 'ListGroups';
    dispatch(fetchHasAccess(screenName));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminId]); */

  const getData = async () => {
    setLoading(true);
    try {
      const data = await getRejectedReasonList();
      setRejectedReasonList(
        data.map((travel: TravelReason) => ({
          id: travel.id,
          isFromReseller: false,
          name: travel.name,
        })),
      );
    } catch (error) {
      toast.add({
        type: 'danger',
        message: t('group.groupAggregation.errorFetch'),
      });
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  const onConfirmSelection = (travelReason: TravelReason) => {
  };

  return (
    <RejectedReasonList
      rejectedReasonList={rejectedReasonList}
      setRejectedReasonList={setRejectedReasonList}
      isLoading={isLoading}
      onConfirmSelection={onConfirmSelection}
      onDeleteSuccess={getData}
      tourLoading={tourLoading}
    />
  );
};

export default RejectedReasonContainer;
